export default __webpack_public_path__ + "static/media/Timesheet.894ddd6e.svg";